import { defineSlotRecipe } from '@chakra-ui/react';

/*
 * v2's `UnorderedList`/`OrderedList` passed `marginStart: '1em'` (before the
 * caller's props, so a call-site `ml` replaced it and `pl` added to it). v3's
 * `List.Root` with the default `marker` variant sets no margin or padding and
 * the preflight zeroes list padding, so bullets hung at the content edge and
 * nested lists lost their hierarchy. The `marker` variant gets v2's indent
 * back here; `plain` (v2's bare `List`) stays unindented.
 */
export const listTheme = defineSlotRecipe({
  slots: ['root', 'item', 'indicator'],
  variants: {
    variant: {
      marker: {
        root: { ms: '1em' },
      },
    },
  },
});

export default listTheme;
